module.exports = __webpack_public_path__ + "d368bdd794ea974b87825204394c6b79.jpg";